//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Services
import { 
    requestGetDateOfNextReservation } from "services/appointment/aboutAppoinment";
//#endregion
//#region Utils
import useMainContext from "utils/context/useMainContext";
import { TIMEOUT_HIDDEN_TOAST_MESSAGE } from "components/ToastMessage/ToastMessage";
import { wait } from "utils/others";
//#endregion

const useStudentFilter = ({
    filters, 
    loadedData,
    helpers: {
        loadingRequest,
        toastMessage
    },
    setTriggerRequest,
    clearSchedules
}) => {
    const { student } = filters.value;
    //#region States
    const [timeoutIdSearch, setTimeoutIdSearch] = useState(null);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!loadedData) return;
        applyStudentFilter();
    }, [student.field]);
    //#endregion
    //#region Functions
    const applyStudentFilter = async () => {
        clearTimeout(timeoutIdSearch);
        // Aplicando filtro normal si no hay estudiante a buscar
        if (!student.field) {
            setTriggerRequest(true);
            return;
        }
        const id = setTimeout(async () => {
            loadingRequest.show("Buscando por asesor...");
            const result = await requestGetDateOfNextReservation(student.field);
            loadingRequest.hide();
            manageDateOfNextReservation(result);
        }, 650);
        setTimeoutIdSearch(id); 
    }
    const manageDateOfNextReservation = async result => {
        // Setteando fecha si fue encontrada
        if (result) {
            const { date, studentId } = result;
            filters.set({
                ...filters.value,
                date,
                student: {
                    ...student,
                    id: studentId
                }
            });
            setTriggerRequest(true);
            return;
        }
        // Avisando que no se pudo encontrar reservas cercanas
        clearSchedules();
        toastMessage.show(
            "No hemos encontrado resultados para este código. Por favor intenta con otro", 
            "error");
    }
    //#endregion
}

export default useStudentFilter;